// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__2HiGs","animloader":"Loader_animloader__1aiS4"};